var _defs, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopicComida(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FEF3C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FDE68A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "plateGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#EA580C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9A3412"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tacoGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FBBF24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#D97706"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 30,
    fill: "url(#bgGrad)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(32, 34)",
    filter: "drop-shadow(0px 3px 2px rgba(154, 52, 18, 0.25))"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -8,-20 C -10,-24 -6,-28 -8,-32",
    fill: "none",
    stroke: "#F59E0B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0,-18 C -2,-22 2,-26 0,-30",
    fill: "none",
    stroke: "#F59E0B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 8,-20 C 6,-24 10,-28 8,-32",
    fill: "none",
    stroke: "#F59E0B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: -6,
    rx: 16,
    ry: 6,
    fill: "#F97316"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -18,-6 C -18,-6 -18,12 0,12 C 18,12 18,-6 18,-6",
    fill: "url(#plateGrad)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: -6,
    rx: 18,
    ry: 4,
    fill: "#C2410C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -14,2 L -10,0 L -6,2 L -2,0 L 2,2 L 6,0 L 10,2 L 14,0",
    fill: "none",
    stroke: "#FFFBEB",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -18,-4 C -22,-4 -22,2 -18,2",
    fill: "none",
    stroke: "#9A3412",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 18,-4 C 22,-4 22,2 18,2",
    fill: "none",
    stroke: "#9A3412",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopicComida);
export default __webpack_public_path__ + "static/media/topic_comida.2a8737d6dc6c7281a234e7ccdeaccee0.svg";
export { ForwardRef as ReactComponent };